module.exports = __webpack_public_path__ + "img/23.06180b59.jpg";